import React from 'react';
import { Result, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { useIntl } from "react-intl";

const Unauthorized = () => {
  const intl = useIntl();
  const history = useHistory();
  return <Result
    status="403"
    title="403"
    subTitle= {intl.formatMessage({
      id: "app.errors.unauthorized",
    })}
    extra={<Button type="primary" onClick={() => {
      history.replace("/");
    }}>{
      intl.formatMessage({
        id: "app.actions.goHome",
      })
    }</Button>}
  />
}

export default Unauthorized;